var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWishlistIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wishlist",
    transform: "translate(-1242 -55)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Container",
    width: 22,
    height: 22,
    transform: "translate(1242 55)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-heart",
    "data-name": "Icon feather-heart",
    d: "M18.788,5.865a4.714,4.714,0,0,0-6.64,0l-.9.9-.9-.9a4.715,4.715,0,0,0-6.64,0,4.649,4.649,0,0,0,0,6.6l.9.9,6.64,6.6,6.64-6.6.9-.9a4.648,4.648,0,0,0,0-6.6Z",
    transform: "translate(1242.177 54.004)",
    fill: "none",
    stroke: "#4b3cee",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlistIcon);
export default __webpack_public_path__ + "static/media/wishlist-icon.63bb7eb5a76e9068bf85fa233de3f4e3.svg";
export { ForwardRef as ReactComponent };